export default __webpack_public_path__ + "static/wallpaper-7-mb-12e35a4d58f0727b916cc7bf94ca801f.png";